<form [formGroup]="formGroup">
    <div class="modal-header">
        <h4 class="modal-title">{{ 'titles_create' | translate: 'online' : 'systems' }}</h4>
    </div>
    <div class="modal-body">
        <p>{{ 'user_api_token_consent_agreement' | translate }}</p>
        <app-input-text-group
            formControlName="tokenName"
            [label]="'properties_token_name' | translate: 'online' : 'systems'"
            [maxLength]="30"></app-input-text-group>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary" type="button" (click)="activeModal.close()">
            {{ 'reporting_CLOSE' | translate }}
        </button>
        <button class="btn btn-primary" type="submit" (click)="submit()">
            {{ 'actions_save' | translate: 'online' : 'common' }}
        </button>
    </div>
</form>
